import type { Certificate } from '@app-types/index'

export const getValidFrom = (certificate: Certificate) =>
  certificate.validity?.from || certificate.validity?.startDate || '-'

export const getValidTo = (certificate: Certificate) =>
  certificate.validity?.to || certificate.validity?.endDate || '-'

export const getValidToDisplay = (certificate: Certificate, noExpiryLabel: string) => {
  const validTo = getValidTo(certificate)
  return validTo === '-' ? noExpiryLabel : validTo
}

export const getPdfHref = (pdf: string) =>
  pdf.startsWith('data:') ? pdf : `data:application/pdf;base64,${pdf}`

export const getCertificateName = (certificate: Certificate) =>
  certificate.type || certificate.name || 'certificate'

export const getCertificateFileName = (certificate: Certificate, vesselName?: string) => {
  const parts = [vesselName, getCertificateName(certificate)]
    .filter((part): part is string => Boolean(part?.trim()))
    .map((part) => part.trim().replace(/[^\p{L}\p{N}]+/gu, '_').replace(/^_+|_+$/g, ''))
    .filter(Boolean)

  return `${parts.join('_') || 'certificate'}.pdf`
}

export const downloadCertificatePdf = (certificate: Certificate, vesselName?: string) => {
  if (!certificate.pdf) {
    return
  }

  const link = document.createElement('a')
  link.href = getPdfHref(certificate.pdf)
  link.download = getCertificateFileName(certificate, vesselName)
  link.click()
}
